import { render } from "./WasiyyahPreview.vue?vue&type=template&id=1ff8aa1c"
import script from "./WasiyyahPreview.vue?vue&type=script&lang=js"
export * from "./WasiyyahPreview.vue?vue&type=script&lang=js"

import "./WasiyyahPreview.vue?vue&type=style&index=0&id=1ff8aa1c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__